module.exports = __webpack_public_path__ + "img/digital3.bae695e0.png";